// Dependencies
import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useRouter } from 'next/router';

// Components
import WithUser from '@components/common/WithUser';
import Loading from '@components/common/Loading';

// State
import { userState } from '@state/auth';

// Constants
import { isStaff } from '@constants/index';

const Redirect = () => {
  const router = useRouter();
  const user = useRecoilValue(userState);
  useEffect(() => {
    if (!user) router.push('/login');
    else if (isStaff(user.role_id)) router.push('/admin/course/management');
    else router.push('courses');
  }, []);

  return <Loading />;
};

export default WithUser(Redirect);
